module.exports = __webpack_public_path__ + "img/settings.1f0f00cb.svg";